import gql from 'graphql-tag';

export const sendContactMessageMutation = gql`
  mutation SendContactMessage($input: SendContactMessageInput) {
    sendContactMessage(input: $input) {
      success
    }
  }
`;
